import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { IoPersonSharp } from "react-icons/io5";
import Navbar from '../home/Navbar';
import axios from 'axios';
import moment from 'moment';
import Footer from "../home/Footer";
import compatibility from "../assets/rootimg/compatibility.png";
import rings from "../assets/rootimg/rings.png";
import { TbPointFilled } from "react-icons/tb";
import solarsystem from "../assets/rootimg/kundli2.jpg";
import Queryform from './Queryform';
import { API_END_POINT } from './Utils/Constant';
import BlogRecommendations from './AstroBlog/BlogRecommendations';
const NewKundli = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    gender: "Male",
    day: "1",
    month: "01",
    year: "2000",
    hour: "15",
    minute: "22",
    second: "00",
    ampm: "AM",
    latitude: "",
    longitude: "",
    birthPlace: "",
    timezone: 5.5
  });
  const [suggestions, setSuggestions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userKundliData, setUserKundliData] = useState(null);
  const [kundliLoading, setKundliLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const birthPlaceInput = useRef(null);

  // Check if user is authenticated
  useEffect(() => {
    const checkAuthStatus = () => {
      const userSession = localStorage.getItem('userSession');
      const authToken = localStorage.getItem('authToken');

      if (userSession && authToken) {
        try {
          const userData = JSON.parse(userSession);
          setIsAuthenticated(true);
        } catch (error) {
          console.error('Error parsing user session:', error);
          setIsAuthenticated(false);
        }
      } else {
        setIsAuthenticated(false);
      }
    };

    checkAuthStatus();
  }, []);

  // Function to check if user's kundli data exists
  const checkUserKundliData = async () => {
    if (!isAuthenticated) return;

    setKundliLoading(true);
    try {
      const userProfileResponse = await axios.get(`${API_END_POINT}user/profile`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      });

      const userProfile = userProfileResponse.data;
      const userId = userProfile?.userId;
      // console.log('Fetched userId:', userId); 

      if (!userId) {
        console.error("User ID not found in the profile response.");
        setUserKundliData(null);
        return;
      }

      const response = await axios.get(`${API_END_POINT}kundli/get-kundli/${userId}`);
      if (response.data && response.data.success) {
        setUserKundliData(response.data.data);
      } else {
        setUserKundliData(null);
      }
    } catch (error) {
      console.error('Error fetching user Kundli data:', error);
      setUserKundliData(null);
    } finally {
      setKundliLoading(false);
    }
  };

  // Check for user's kundli data when component mounts or user changes
  useEffect(() => {
    if (isAuthenticated) {
      checkUserKundliData();
    } else {
      setUserKundliData(null);
    }
  }, [isAuthenticated]);

  const handlePlaceSearch = async (e) => {
    const query = e.target.value;
    if (query.length < 3) {
      setSuggestions([]);
      return;
    }

    try {
      const response = await axios.get(`${API_END_POINT}data/places/suggestions?city=${query}`);
      if (response.data) {
        setSuggestions(response.data);
      }
    } catch (error) {
      console.error('Error fetching place suggestions:', error);
      setSuggestions([]);
    }
  };

  const handleSuggestionSelect = (suggestion) => {
    setFormData((prevData) => ({
      ...prevData,
      birthPlace: suggestion.place_name,
      latitude: suggestion.latitude,
      longitude: suggestion.longitude,
    }));
    setSuggestions([]);
    setSelectedIndex(null);
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      setSelectedIndex((prevIndex) => (prevIndex === null ? 0 : Math.min(suggestions.length - 1, prevIndex + 1)));
    } else if (e.key === "ArrowUp") {
      setSelectedIndex((prevIndex) => (prevIndex === null ? 0 : Math.max(0, prevIndex - 1)));
    } else if (e.key === "Enter" && selectedIndex !== null) {
      handleSuggestionSelect(suggestions[selectedIndex]);
    }
  };

  const kundliSteps = [
    { steps: 'Visit the AstroTellers Website', description: "Go to the ‘Kundli’ option on the website." },
    { steps: 'Enter Required Information', description: "To ensure the most accurate predictions, provide precise details such as your date of birth, time of birth, and any other relevant information, as the accuracy of the predictions depends on the accuracy of the details you provide." },
    { steps: 'Submit the Information', description: "After entering your details, click on Submit." },
    { steps: 'Receive Your Detailed Janam Kundli', description: "Within seconds, your personalized Janam Kundli will be generated, offering a comprehensive analysis that includes textual insights into your personality traits both strengths and weaknesses along with charts showing the positions of planets in houses based on your birth details." },
    { steps: 'Understand Your Janam Kundli', description: "Within seconds, your personalized Janam Kundli will be generated, offering a comprehensive analysis that includes textual insights into your personality traits both strengths and weaknesses along with charts showing the positions of planets in houses based on your birth details." },
    { steps: 'Janam Kundli Matching Service', description: "Our website also provides a Janam Kundli matching service, which is particularly important when planning for marriage, as it assesses the compatibility between the couple based on their birth charts." },
    { steps: 'Importance of Janam Kundli Matching', description: "The process involves Gun matching, where the gunas (points) of two individuals are compared, and also includes checking the compatibility of Manglik Dosh. If necessary, remedies for Manglik Dosh may be suggested." },
    { steps: 'Understanding the Results', description: "If the Kundlis do not match, the astrologer will explain why and suggest potential remedies." },
    { steps: 'Free Kundli Predictions and Services', description: "Access your free online Janam Kundli through the website’s free Kundli chart option, where you can also receive free Kundli predictions and personalized readings." },

  ]
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("Form data before submitting:", formData);

    setLoading(true);
    try {
      const { day, month, year, hour, minute, latitude, longitude, timezone, ampm } = formData;

      // Convert hour to 24-hour format
      let hourIn24Format = parseInt(hour);
      if (ampm === "PM" && hourIn24Format < 12) {
        hourIn24Format += 12; // Convert PM hour to 24-hour format
      } else if (ampm === "AM" && hourIn24Format === 12) {
        hourIn24Format = 0; // Convert 12 AM to 0 hours
      }

      // Define predefined parameters for divisional chart request
      const predefinedParams = {
        div: 'kp_chalit',  // Divisional chart type
        color: '#ff3366',  // Color (hex code)
        style: 'north',    // Style of the chart
        font_size: 16,     // Font size for chart text
        font_style: 'roboto', // Font style for chart text
        colorful_planets: 1, // Display colorful planets
        size: 300,         // Chart size
        stroke: 2,         // Stroke width for chart
        format: 'base64',    // Response format
        year: new Date().getFullYear(), // Current year
        transit_date: moment().format('DD/MM/YYYY') // Current date using moment.js
      };

      // Construct the request body
      const requestBody = {
        name: formData.name,
        gender: formData.gender,
        day: day,
        month: month,
        year: year,
        hour: hour,
        minute: minute,
        latitude: latitude,
        longitude: longitude,
        ...predefinedParams // Add predefined params
      };

      // Prepare request data for natal chart API
      // const requestData3 = {
      //     year: parseInt(year),
      //     month: parseInt(month),
      //     date: parseInt(day),
      //     hours: hourIn24Format,
      //     minutes: parseInt(minute),
      //     seconds: 0,
      //     latitude: parseFloat(latitude),
      //     longitude: parseFloat(longitude),
      //     timezone: parseFloat(timezone),
      //     config: {
      //         "observation_point": "topocentric",
      //         "ayanamsha": "lahiri"
      //     }
      // };

      const API_KEY = import.meta.env.VITE_FREEASTROAPI_KEY;
      // Send POST request to get planets data
      const planetsResponse = await axios.post(`${API_END_POINT}kundlireport/planetsdata`, requestBody);
      // console.log('Planets data:', planetsResponse.data);

      // Send POST request for ascendant report and personal details
      const ascendantResponse = await axios.post(`${API_END_POINT}kundlireport/ascendantreport`, requestBody);
      const personalDetailsResponse = await axios.post(`${API_END_POINT}kundlireport/personaldetails`, requestBody);



      // const response3 = await axios.post(`${API_END_POINT}kundlireport/divisionalchartimage`, requestData3, {
      //     headers: { 'x-api-key': API_KEY }
      // });
      // console.log(response3);

      // Combine the data to be sent to the result page
      const kundliData = {
        planetsData: planetsResponse.data,
        ascendantData: ascendantResponse.data,
        personalDetails: personalDetailsResponse.data,
        // divisionalChartSvg: response3.output, // Send the raw SVG data
      };

      // Navigate to KundliResult.jsx and pass the combined data
      navigate('/kundliresult', { state: { kundliData } });

    } catch (error) {
      console.error('Error fetching Kundli data:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleSubmit1 = (e) => {
    navigate('/login');
  }
  const kundlimatchinghandler = (e) => {
    e.preventDefault();
    navigate('/kundlimatching');
  }
  const compatibilityhandler = (e) => {
    e.preventDefault();
    navigate('/compatibility');
  }
  return (
    <>
      <div>
        <section className='bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen'>
          <div>
            <Navbar />
          </div>
          <div className="px-4 sm:px-8 md:px-16 lg:px-32 mt-8">
            {/* Header Section */}
            <div className="text-center">
              <h1 className="text-3xl sm:text-4xl font-serif font-bold text-secondary mt-10">KUNDLI</h1>
              <h2 className="text-lg font-serif sm:text-xl font-semibold text-secondary">
                Get your instant and accurate Janam Kundli now
              </h2>
            </div>
            {/* Separator with Image */}
            <div className="flex items-center justify-center mt-4">
              <hr className="border-black h-[2px] w-24 sm:w-36 md:w-48 lg:w-60 mr-2" />
              <img
                src={solarsystem}
                alt="kundli.png"
                className="w-10 h-10 rounded-full object-cover bg-white shadow-2xl hover:shadow-xl"
              />
              <hr className="border-black h-[2px] w-24 sm:w-36 md:w-48 lg:w-60 ml-2" />
            </div>

            {/* Kundli Description */}
            <div className="flex justify-center mt-4">
              <p className="text-black text-sm sm:text-base max-w-3xl text-center">
                Kundli is a traditional astrological system that combines aspects of the sun, moon, and planets to predict
                the relationships between people. It was introduced by Swami Vivekananda in 1931 and is widely used today.
              </p>
            </div>

            {/* Kundli Information Section */}
            <div className="mt-8 text-justify max-w-6xl mx-auto">
              <h2 className="text-left text-lg font-bold text-secondary">Create your free Kundli online - Receive a detailed birth chart with predictions</h2>
              <p className="mt-2">
                Looking for a free Kundli prepared by expert astrologers? You've come to the right place. The free Kundli available on AstroTellers is 100% authentic, created with insights from over 50 expert astrologers. This comprehensive birth chart offers a glimpse into various aspects of your life, including career, love, marriage, business, and more. The Kundli generated by our advanced software is as accurate as any traditional chart, and can be used for purposes such as matchmaking, marriage compatibility, and future predictions.
              </p>
              <p className="mt-2">
                When it comes to future predictions, the Kundli provided by AstroTellers takes into account the movement of all the planets throughout your life, from birth up to a span of 100 years. This thorough approach helps you understand not only the current circumstances you're facing but also what lies ahead in your future. So, if you're feeling uncertain about any aspect of your life, the online Kundli can be your guide. Try the free online Kundli today and let us know your thoughts!
              </p>
            </div>
            {/* Kundli Form & Saved Kundli Section */}
            <div className="flex flex-col md:flex-row  gap-8 mt-8">
              {/* Kundli Form */}
              <form onSubmit={handleSubmit} className="bg-gray-100 lg:w-3/5 md:w-3/5 sm:w-full mx-auto shadow-md rounded-lg p-6 flex-1">
                <h2 className="text-xl sm:text-xl text-white bg-secondary rounded-full py-1 text-center font-bold mb-4">New Kundli</h2>

                {/* Name Input */}
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Name*
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    placeholder="Enter Your Full Name"
                    onChange={handleChange}
                    required
                    className="w-full border border-secondary rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
                  />
                </label>

                {/* Gender Selection */}
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Gender*
                  <select
                    name="gender"
                    value={formData.gender}
                    onChange={handleChange}
                    required
                    className="w-full bg-white border border-secondary rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
                  >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </label>

                {/* Date of Birth Selection */}
                <div className="grid grid-cols-3 gap-4 mb-4">
                  {/* Day */}
                  <label className="block text-gray-700 text-sm font-bold">
                    Day*
                    <select
                      name="day"
                      value={formData.day}
                      onChange={handleChange}
                      required
                      className="w-full bg-white border border-secondary rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
                    >
                      {Array.from({ length: 31 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                      ))}
                    </select>
                  </label>

                  {/* Month */}
                  <label className="block text-gray-700 text-sm font-bold">
                    Month*
                    <select
                      name="month"
                      value={formData.month}
                      onChange={handleChange}
                      required
                      className="w-full bg-white border border-secondary rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
                    >
                      {Array.from({ length: 12 }, (_, i) => (
                        <option key={i + 1} value={String(i + 1).padStart(2, '0')}>{String(i + 1).padStart(2, '0')}</option>
                      ))}
                    </select>
                  </label>

                  {/* Year */}
                  <label className="block text-gray-700 text-sm font-bold">
                    Year*
                    <input
                      type="number"
                      name="year"
                      value={formData.year}
                      onChange={handleChange}
                      required
                      className="w-full border border-secondary rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
                    />
                  </label>
                </div>
                <div className="grid grid-cols-3 gap-4 mb-4">
                  <label className="block text-gray-700 text-sm font-bold">
                    Hour*
                    <input
                      type="number"
                      name="hour"
                      value={formData.hour}
                      onChange={handleChange}
                      required
                      className="shadow appearance-none border border-secondary rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                  </label>
                  <label className="block text-gray-700 text-sm font-bold">
                    Minute*
                    <input
                      type="number"
                      name="minute"
                      value={formData.minute}
                      onChange={handleChange}
                      required
                      className="shadow appearance-none border border-secondary rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                  </label>
                  <label className="block text-gray-700 text-sm font-bold">
                    Second
                    <input
                      type="number"
                      name="second"
                      value={formData.second}
                      onChange={handleChange}
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight border-secondary focus:outline-none focus:shadow-outline"
                    />
                  </label>
                </div>
                {/* Birth Place Input with Autocomplete */}
                <label className="block text-gray-700 text-sm font-bold mb-4">
                  Birth Place*
                  <input
                    type="text"
                    name="birthPlace"
                    ref={birthPlaceInput}
                    placeholder="Enter Your Birth Place"
                    value={formData.birthPlace}
                    onChange={handleChange}
                    onInput={handlePlaceSearch}
                    onKeyDown={handleKeyDown}
                    required
                    className="w-full border border-secondary rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-secondary"
                  />
                </label>

                {/* Display place suggestions */}
                {suggestions.length > 0 && (
                  <div className="bg-white border border-gray-300 rounded-md mt-2 max-h-60 overflow-y-auto">
                    {suggestions.map((suggestion, index) => (
                      <div
                        key={index}
                        onClick={() => handleSuggestionSelect(suggestion)}
                        className={`cursor-pointer p-2 hover:bg-gray-200 ${selectedIndex === index ? "bg-gray-300" : ""}`} // Highlight the selected suggestion
                      >
                        {suggestion.place_name}
                      </div>
                    ))}
                  </div>
                )}

                {/* Submit Button */}
                <button
                  type="submit"
                  className="bg-gray-900 w-full text-white font-bold py-2 px-4 rounded-md hover:bg-success transition-all focus:outline-none"
                  disabled={loading} // Disable button when loading
                >
                  {loading ? "Generating..." : "Generate Kundli"}
                </button>
              </form>

              {/* Saved Kundli Section */}
              <div className="bg-gray-100 shadow-md rounded-lg p-6 lg:w-2/5 w-full md:w-2/5 flex flex-col justify-center items-center mx-auto">
                <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-secondary mb-2">
                  Saved Kundli
                </h2>

                {isAuthenticated ? (
                  kundliLoading ? (
                    <p className="text-gray-700 mb-4 text-center text-sm sm:text-base">
                      Loading your kundli data...
                    </p>
                  ) : userKundliData ? (
                    <div className="flex flex-col items-center w-full">
                      <p className="text-gray-700 mb-4 text-center text-sm sm:text-base">
                        Your kundli data is available!
                      </p>
                      <button
                        onClick={() => navigate('/kundliresult', { state: { kundliData: userKundliData } })}
                        className="bg-gray-900 text-white transition duration-300 font-semibold py-2 px-4 sm:px-6 rounded-md hover:bg-success focus:outline-none focus:ring-2 focus:ring-success focus:ring-opacity-50 flex items-center mb-3 w-full justify-center"
                      >
                        View Your Kundli
                      </button>
                      <button
                        onClick={() => navigate('/kundlimatching')}
                        className="bg-secondary text-white transition duration-300 font-semibold py-2 px-4 sm:px-6 rounded-md hover:bg-success focus:outline-none focus:ring-2 focus:ring-success focus:ring-opacity-50 flex items-center w-full justify-center"
                      >
                        Match Kundli
                      </button>
                    </div>
                  ) : (
                    <div className="flex flex-col items-center w-full">
                      <p className="text-gray-700 mb-4 text-center text-sm sm:text-base">
                        You don't have any saved kundli yet. Generate one now!
                      </p>
                      <button
                        onClick={() => document.querySelector('form').scrollIntoView({ behavior: 'smooth' })}
                        className="bg-gray-900 text-white transition duration-300 font-semibold py-2 px-4 sm:px-6 rounded-md hover:bg-success focus:outline-none focus:ring-2 focus:ring-success focus:ring-opacity-50 flex items-center"
                      >
                        Generate Kundli
                      </button>
                    </div>
                  )
                ) : (
                  <>
                    <p className="text-gray-700 mb-4 text-center text-sm sm:text-base">
                      Please login to check your saved horoscope!
                    </p>
                    {/* Login Button (Visible on All Screens) */}
                    <div className="flex items-center space-x-4">
                      <button
                        onClick={() => navigate('/login')}
                        className="bg-gray-900 text-white transition duration-300 font-semibold py-2 px-4 sm:px-6 rounded-md hover:bg-success focus:outline-none focus:ring-2 focus:ring-success focus:ring-opacity-50 flex items-center"
                      >
                        <IoPersonSharp className="h-4 w-4 mr-2" />
                        Login
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="mt-16 flex flex-col items-center px-4 sm:px-8 md:px-12 lg:px-32">
            {/* Main Heading */}
            <h2 className="text-xl sm:text-2xl font-bold text-center mt-8 text-secondary">
              Free Online Kundli For Future Insights
            </h2>
            <h3 className="text-lg sm:text-xl text-center text-gray-500">
              Generate Your Kundli Using Your Date of Birth
            </h3>

            {/* Content Section */}
            <div className="mt-6 text-justify text-sm sm:text-base leading-relaxed max-w-6xl">
              <p>
                The Kundli is one of the most essential elements of astrology. It provides detailed insights into the positions of stars and planets at the time of your birth, forming the basis for various life predictions. These predictions cover areas such as love, career, health, business, finance, and marriage. In simple terms, creating a Kundli is crucial for anyone seeking deeper understanding and guidance, and it can gradually enhance decision-making abilities over time.
              </p>
              <p className="mt-2">
                A Janam Kundli is created by analyzing the precise positions of the planets at the time of your birth. Based on this, your Sun sign, Moon sign, and other astrological aspects are determined. The Kundli combines both predictions and charts that help the astrologer gain insights into your future highlighting the periods when hard work will be essential and the times when luck will favor you abundantly.
              </p>
              <p className="mt-2">
                With the shift towards a more tech-savvy culture, people now prefer accessing services at their fingertips. As a result, the process of creating a Janam Kundali has moved online, making it more affordable, accessible, and detailed. At AstroTellers, we offer a free online Janam Kundali to our extensive user base, allowing everyone the opportunity to learn more about themselves and make better-informed life decisions..
              </p>
              <p className="mt-2">
                Many people often wonder whether online Kundli astrology is as accurate as the traditional process, or if getting a Kundli made by a pandit or Vedic astrologer is still the best option. While a Kundli created by a Vedic astrologer certainly holds the highest regard (and our expert astrologers can create one for you), online Kundli software is equally precise. In fact, an online Kundli can often provide more detailed insights compared to the traditional physical method.
              </p>
              <p className="mt-2">
                Simply put, just as a physical Kundli is created by skilled Vedic astrologers and pandits, an online Kundli is also prepared based on astrological predictions by experts. The only difference lies in the medium through which the information is shared—digitally. The digitization of the Kundli offers additional benefits, such as access to information in multiple languages.
              </p>
              <p className="mt-2">
                Alternatively, you can always have a physical Janam Kundali report created by our astrologers, which will be delivered to you in person..
              </p>
            </div>

            {/* Steps Section */}
            <div className="mt-8 text-justify text-sm sm:text-base max-w-6xl">
              <h2 className="text-xl sm:text-2xl font-bold text-secondary">How to Create Kundli - Steps</h2>
              {kundliSteps.map((content, index) => (
                <div key={index} className="mt-4">
                  <div className="flex items-center">
                    <TbPointFilled className="text-primary mr-2" />
                    <h2 className="font-bold">{content.steps}</h2>
                  </div>
                  <p className="ml-6">{content.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h2 className='text-2xl font-bold text-center mt-8 text-secondary'>COMPLIMENTARY SERVICES</h2>
          </div>
          <div className="flex flex-col md:flex-row items-stretch gap-4 md:gap-6 px-4 md:px-12 lg:px-52">
            {/* Card 1 */}
            <div className="bg-white w-full md:w-1/2 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto mt-5 p-4 rounded-lg">
              <div className="flex flex-col sm:flex-row items-center">
                <img
                  src={rings}
                  alt="kundli.png"
                  className="w-24 h-20 sm:w-32 sm:h-24 m-2 sm:m-4 border rounded-xl border-white bg-white"
                />
                <div className="text-center sm:text-left">
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">
                    Kundli Matching
                  </h3>
                  <p className="text-sm sm:text-base text-justify mb-4">
                    Kundli Matching helps you find a match for your astrological traits
                    and preferences. By comparing your birth chart with others in the
                    database, you can find a person who shares your similarities and
                    characteristics.
                  </p>
                  <button
                    onClick={kundlimatchinghandler}
                    className="bg-secondary w-full sm:w-fit h-auto p-3 rounded-md hover:bg-success text-white"
                  >
                    Match Kundli
                  </button>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="bg-white w-full md:w-1/2 flex flex-col justify-between shadow-lg hover:shadow-xl h-auto mt-5 p-4 rounded-lg">
              <div className="flex flex-col sm:flex-row items-center">
                <img
                  src={compatibility}
                  alt="compatibility.png"
                  className="w-24 h-20 sm:w-32 sm:h-24 m-2 sm:m-4 border rounded-xl border-white bg-white"
                />
                <div className="text-center sm:text-left">
                  <h3 className="text-lg sm:text-xl font-bold mb-2 text-secondary">
                    Compatibility
                  </h3>
                  <p className="text-sm sm:text-base text-justify mb-4">
                    Compatibility helps you understand how well your astrological traits
                    align with those of another person. By comparing your birth chart with
                    others in the database, you can find a person who shares your
                    similarities and characteristics.
                  </p>
                  <button
                    onClick={compatibilityhandler}
                    className="bg-secondary w-full sm:w-fit h-auto p-3 rounded-md hover:bg-success text-white"
                  >
                    Check Compatibility
                  </button>
                </div>
              </div>
            </div>
          </div>
          <BlogRecommendations />
          <div>
            <Queryform />
          </div>
          <div className='mt-10'>
            <Footer />
          </div>
        </section>
      </div>
    </>
  )
}

export default NewKundli
